import { ElementRef, Injector, Directive, Inject, input } from '@angular/core';
import app from '@app/app';
import { UpgradeComponent } from '@angular/upgrade/static';
import { angularjs } from '@app/service/migration-helpers/angularjs.injection';

app.component('ltUibPopover', {
  bindings: {
    uibPopover: '@',
    uibPopoverHtml: '@',
    popoverTrigger: '@',
    popoverPlacement: '@',
    popoverClass: '@',
    popoverEnable: '@'
  },
  transclude: true,
  template: `
    <span
      ng-if="$ctrl.uibPopoverHtml"
      uib-popover-html="$ctrl.uibPopoverHtml"
      popover-trigger="'{{$ctrl.popoverTrigger || 'mouseenter'}}'"
      popover-placement="{{$ctrl.popoverPlacement || 'top'}}"
      popover-class="{{$ctrl.popoverClass || ''}}"
      popover-enable="{{$ctrl.popoverEnable !== false}}">
      <ng-transclude></ng-transclude>
    </span>
    <span
      ng-if="!$ctrl.uibPopoverHtml"
      uib-popover="{{$ctrl.uibPopover}}"
      popover-trigger="'{{$ctrl.popoverTrigger || 'mouseenter'}}'"
      popover-placement="{{$ctrl.popoverPlacement || 'top'}}"
      popover-class="{{$ctrl.popoverClass || ''}}"
      popover-enable="{{$ctrl.popoverEnable !== false}}">
      <ng-transclude></ng-transclude>
    </span>
  `
});

@Directive({
  selector: 'lt-uib-popover',
  providers: [
    {
      provide: '$scope',
      useFactory: (rootScope: any) => rootScope.$new(),
      deps: [angularjs.$rootScope]
    }
  ]
})
export class UibPopoverComponentWrapper extends UpgradeComponent {
  uibPopover = input('');
  uibPopoverHtml = input('');
  popoverTrigger = input('mouseenter');
  popoverPlacement = input('top');
  popoverClass = input('');
  popoverEnable = input(true);

  constructor(@Inject(ElementRef) elementRef: ElementRef, @Inject(Injector) injector: Injector) {
    super('ltUibPopover', elementRef, injector);
  }
}
